import {html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import store from '../../../store';
import {ListSelectItem} from '../../../components/widgets/listSelectItem';
import {selectSolarHeight, selectSolarVersion} from '../../solarSelectors';

@customElement('height-select-item')
export class HeightSelectItem extends ListSelectItem {

	render() {
		const s = store.getState();
		const baseHeightValue = selectSolarHeight(s);
		const baseHeight = baseHeightValue ? parseInt(baseHeightValue, 10) / 10 : 0;
		const height = parseInt(this.option.id, 10);
		let label = height + ' m';
		if (baseHeight > 0) {
			label = baseHeight + height + ' m';
		}
		return html`
			<div class="item ${classMap({selected: this.isSelected(), disabled: this.isDisabeled(), hideDisabled: this.hideDisabled, fixed: !this.canBeExcluded()})}">
				<button @click="${this.setOption}">
					${label}
				</button>
				<!--
				${when(this.option.info && this.option.info !== '' && this.option.info !== null, () => html`
					<div class="hoverinfo">
						<div class="content">
							${this.option.info[this.lang]}
						</div>
					</div>
				`)}
				-->
			</div>
		`;
	}
}
